import { Component, ElementRef, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoadingAttributeComponent } from '@shared/ui';
import { TranslateModule } from '@ngx-translate/core';
import { CaseTypeData } from '../../state/case-type.state';

export enum CaseTypeColumn {
  NAME = 'name',
  DESCRIPTION = 'description',
  WORKSPACES = 'workspaces',
  CASES = 'cases',
  EDIT = 'edit',
  DELETE = 'delete',
}

@Component({
  selector: 'ts-case-types-list',
  templateUrl: './case-types-list.component.html',
  styleUrls: ['./case-types-list.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    MatTableModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    LoadingAttributeComponent,
  ],
})
export class CaseTypesListComponent implements OnChanges {
  @Input() items: CaseTypeData[] = [];
  @Input() loading = false;
  @Input() noCaseTypes = false;
  @Input() columns: CaseTypeColumn[] = [
    CaseTypeColumn.NAME,
    CaseTypeColumn.DESCRIPTION,
    CaseTypeColumn.WORKSPACES,
    CaseTypeColumn.CASES,
    CaseTypeColumn.EDIT,
    CaseTypeColumn.DELETE,
  ];

  @Output() editClicked = new EventEmitter<CaseTypeData>();
  @Output() deleteClicked = new EventEmitter<CaseTypeData>();

  // Store the container height when loading starts to prevent layout jumps
  public containerHeight: number | null = null;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    // When loading starts, capture the current height
    if (changes['loading'] && changes['loading'].currentValue === true) {
      const element = this.elementRef.nativeElement as HTMLElement;
      if (element && element.offsetHeight > 0) {
        this.containerHeight = element.offsetHeight;
      }
    }
    // When loading ends, clear the fixed height
    if (changes['loading'] && changes['loading'].currentValue === false) {
      this.containerHeight = null;
    }
  }

  get visibleColumns(): string[] {
    return this.columns.map((col) => col.valueOf());
  }
}
